<button id="btnModalLightbox" data-bs-toggle="modal" data-bs-target="#modalLightBox">
  Click
</button>

<!-- The Modal/Lightbox -->
<div class="modal fade fx-modal" id="modalLightBox" #modal>
  <div class="modal-dialog modal-xl modal-fixed modal-dialog-centered">
    <span class="btn-close cursor" data-bs-dismiss="modal">&times;</span>
    <div class="modal-content">
      <div class="mySlides m-auto" *ngFor="let file of files; let i = index">
        <div>
          <div class="numbertext">
            <!--<span>{{ i + 1 }} / {{ files.length }}</span>-->
            <span class="text-uppercase">{{file.title}}</span>
          </div>
          <div class="image">
            <!-- <img class="zoom zoom{{i}}" src="{{ file.url }}" (mousemove)="startZoom(i)"
               attr.data-zoom-image="{{ file.url }}" /> -->
              <lib-ngx-image-zoom
                [thumbImage]=file.url
                [fullImage]="file.url"
                [magnification]="1"
                [enableScrollZoom]="true"
                [enableLens]="true"
                [scrollStepSize]="0.1"
                [lensWidth]="200"
                [lensHeight]="200"
              ></lib-ngx-image-zoom>
            </div>
        </div>
        <fx-save-image [data]="file.url" [name]="file.title"></fx-save-image>
      </div>
      <!-- Next/previous controls -->
      <a class="prev" (click)="plusSlides(-1)">&#10094;</a>
      <a class="next" (click)="plusSlides(1)">&#10095;</a>
    </div>
  </div>
</div>

